import React from "react";

export default function DataDeletionInstructions() {
    return (
        <div className="tw-p-6 tw-bg-gray-100 tw-min-h-screen tw-flex tw-justify-center tw-items-center">
            <div className="tw-bg-white tw-shadow-lg tw-rounded-2xl tw-p-8 tw-max-w-xl tw-w-full">
                <h1 className="tw-text-2xl tw-font-bold tw-mb-4">Data Deletion Instructions</h1>
                <p className="tw-text-base tw-text-gray-700 tw-mb-4">
                    If you wish to delete your data associated with our app, please follow these steps:
                </p>
                <ol className="tw-list-decimal tw-ml-6 tw-text-gray-700 tw-mb-4">
                    <li>Log in to your account.</li>
                    <li>Click on your profile image at the top-right corner of the navigation bar.</li>
                    <li>A popup menu will appear. Click on the "Delete Account" option.</li>
                    <li>Confirm your action when prompted.</li>
                </ol>
                <p className="tw-text-base tw-text-gray-700">
                    Once the request is confirmed, your account and all associated user data will be permanently deleted from our systems.
                </p>
                <p className="tw-text-base tw-text-gray-700 tw-mt-4">
                    If you need any assistance, please contact us at{" "}
                    <a href="mailto:shahfaaad530@gmail.com" className="tw-text-blue-600 hover:tw-underline">
                        shahfaaad530@gmail.com
                    </a>
                    .
                </p>
            </div>
        </div>
    );
}
